import React from 'react'

export type AgTechFastTab = {
    title: string,
    actionPane?: () => React.ReactNode,
    content: () => React.ReactNode,
    config?: {
        tabHeight?: number,
        tabClasses?: string
    }
}

export type AgTechFastTabListProps = {
    tabs: AgTechFastTab[]
}

const AgTechFastTabList = (props: AgTechFastTabListProps) => {
    return (
        <div className='stretched row-based container pl-1'>
            <div className='stretched row-based non-scrollable container'>
                {props.tabs.map((tab, index) => {
                    let tabPadding = index === 0 ? '' : 'mt-4';

                    return (
                        <div key={tab.title} className={`row-based pr-2 ${tabPadding} flex-hold non-scrollable container ${tab.config?.tabClasses ?? ''}`}>
                            <div className={`${index === 0 ? 'pb-2 pt-3' : 'pb-2 pt-3'} px-1 pr-4 bottom-bordered font-semibold wide column-based-vertically-centered container`}>
                                <h1 className='font-size-small font-semibold mt-half'>{tab.title}</h1>
                                {tab.actionPane ? (
                                    <div className='tall ml-auto container'>
                                        {tab.actionPane()}
                                    </div>
                                ) : null}
                            </div>
                            <div className='row-based pt-3 non-scrollable container' style={{ minHeight: tab.config?.tabHeight ?? undefined }}>
                                {tab.content()}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default AgTechFastTabList